import type { DateRange } from '~shared/ui/date-range-picker';

import { endOfDay, startOfDay, subDays } from 'date-fns';

export type OrdersFiltersValue = {
  period: DateRange;
  merchantIds: string[];
  posIds: string[];
  statuses: string[];
};

export const DEFAULT_ORDERS_PERIOD_DAYS = 7;
export const MAX_ORDERS_PERIOD_DAYS = 60;

export const getDefaultOrdersDateRange = (): {
  startDate: string;
  endDate: string;
} => ({
  startDate: startOfDay(
    subDays(new Date(), DEFAULT_ORDERS_PERIOD_DAYS)
  ).toISOString(),
  endDate: endOfDay(new Date()).toISOString(),
});

export const getDefaultOrdersFilter = (): OrdersFiltersValue => ({
  period: getDefaultOrdersDateRange(),
  merchantIds: [],
  posIds: [],
  statuses: [],
});
